export const LOCALE_LIST = ['ko', 'en', 'th'] as const;
export const DEFAULT_LOCALE = 'ko';
